
import './App.css';
import Navigation from './Pages/Navigation';

function App() {
  return (
    <Navigation/>
  );
}

export default App;
